import { DataGrid } from '@nokia-csf-uxr/ccfk';
import { useState, useRef } from 'react';
import { AllCommunityModules } from '@ag-grid-community/all-modules';

/**
 * BoQ data grid
 * @param {*} props
 * props.data : get boq detail information
 * @returns 
 */
const BoQDetails = (props) => {

    const [rowData, setRowData] = useState([]);
  
    const gridApi = useRef(null);
  
    const valuesUpdated = useRef(false);
  
    if(valuesUpdated.current) {
      valuesUpdated.current = false;
    } else {
      setRowData(props.data)
      valuesUpdated.current = true;
    }

    const getRowStyle = params => {
      if (params.data.productName === '') {
          return { background: 'lightgrey' };
      }
    };

    return (
      <DataGrid
        modules={AllCommunityModules}
        wrapperProps={{
          style: {
            height: '100%',
            minHeight: '690px',
            width: '99%'
          }
        }}
        rowData={rowData?.length == 0 ? [] : rowData}
        suppressContextMenu
        suppressColumnMoveAnimation={true}
        animateRows={false}
        defaultColDef={{
          menuTabs: ['filterMenuTab']
        }}
        overlayNoRowsTemplate="No Bill of Material for this link"
        columnDefs={ boqColumnsDefs() }
        getRowStyle={getRowStyle}     
        onGridReady={(params) => {
          gridApi.current = params.api;
        }}
        onFirstDataRendered = {(params) => {
          params.api.sizeColumnsToFit();
        }}
      />
    );
  }; 
  
  export default BoQDetails;

  /**
 * Column definitions
 */
const boqColumnsDefs = () => [
    {
      headerName: 'Part number',
      field: 'partNumber',
      width: 150,
      cellStyle: {fontSize: '14px'},
      sortable: false
    },
    {
      headerName: 'Description',
      field: 'productName',
      width: 300,
      cellStyle: {fontSize: '14px'},
      sortable: false
    },
    {
      headerName: 'Quantity',
      field: 'Quantity',
      width: 125,
      cellStyle: {fontSize: '14px'},
      sortable: false
    }
  ];

;